export class Version {
    static readonly YEAR: number = new Date().getFullYear();
    static readonly Version: string = '4.0.0';
}
